import { Linkedin, Phone } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { PHONE_DISPLAY, PHONE_TEL, Wordmark } from "./Header";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#010307] border-t border-white/10 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-16 pb-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div>
            <Wordmark imgClass="h-11" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
              Senior supply chain, logistics and In-Country Value support — locally and overseas.
            </p>
          </div>
          <nav className="flex flex-col gap-3 text-sm" aria-label="Footer">
            <a href="#capabilities" data-testid="footer-capabilities-link" className="text-slate-400 hover:text-teal-300 transition-colors duration-300">Capabilities</a>
            <a href="#why-coastal" data-testid="footer-why-coastal-link" className="text-slate-400 hover:text-teal-300 transition-colors duration-300">Why Coastal</a>
            <a href="#about" data-testid="footer-about-link" className="text-slate-400 hover:text-teal-300 transition-colors duration-300">About James</a>
            <a href="#contact" data-testid="footer-contact-link" className="text-slate-400 hover:text-teal-300 transition-colors duration-300">Contact</a>
          </nav>
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-slate-500">Call James</p>
            <a
              href={PHONE_TEL}
              data-testid="footer-call-james-btn"
              className="mt-2 inline-flex items-center gap-2 font-display text-xl md:text-2xl text-slate-100 hover:text-teal-300 transition-colors duration-300"
            >
              <Phone className="h-4 w-4 text-teal-400" />
              {PHONE_DISPLAY}
            </a>
            <p className="mt-3 text-sm text-slate-500">Point Frederick, NSW, Australia</p>
            <a
              href="https://au.linkedin.com/in/james-pearson-82169932"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="mt-4 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-teal-300 transition-colors duration-300"
            >
              <Linkedin className="h-4 w-4 text-teal-400" />
              James Pearson on LinkedIn
            </a>
          </div>
        </div>

        <div className="mt-16 select-none" aria-hidden="true">
          <p className="font-display whitespace-nowrap leading-[0.85] text-[10.5vw] text-white/[0.04] tracking-tight">
            COASTAL LOGISTICS
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/5 pt-6 text-xs text-slate-600">
          <p>
            © {new Date().getFullYear()} Coastal Logistics Solutions Pty Ltd ·{" "}
            <span data-testid="footer-abn">ABN 39 687 408 984</span>
          </p>
          <div className="flex items-center gap-5">
            <Dialog>
              <DialogTrigger asChild>
                <button
                  type="button"
                  data-testid="footer-privacy-btn"
                  className="text-slate-500 hover:text-teal-300 transition-colors duration-300"
                >
                  Privacy
                </button>
              </DialogTrigger>
              <DialogContent
                data-testid="privacy-dialog"
                className="bg-[#07131F] border-white/10 text-slate-200 max-w-lg"
              >
                <DialogHeader>
                  <DialogTitle className="font-display text-2xl text-slate-50">Privacy</DialogTitle>
                  <DialogDescription className="text-slate-400">
                    How Coastal Logistics Solutions handles your details.
                  </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 text-sm leading-relaxed text-slate-300">
                  <p>
                    When you send an enquiry, we collect your name, email address, company (if
                    provided) and message. We use these details only to respond to your enquiry.
                  </p>
                  <p>
                    Your details are never sold, rented or added to marketing lists, and are not
                    shared with third parties except the service providers needed to operate this
                    website and deliver email.
                  </p>
                  <p>
                    Enquiry records are stored securely and retained only as long as needed to
                    manage our business relationship.
                  </p>
                  <p>
                    To access, correct or delete your details, call James on{" "}
                    <a href={PHONE_TEL} className="text-teal-300 hover:text-teal-200">
                      +61 0401 712 775
                    </a>
                    .
                  </p>
                </div>
              </DialogContent>
            </Dialog>
            <p>Point Frederick, NSW — Australia</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
